import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import {
  type ApiError,
  type ApiResponse,
  addActionNameToMutationResult,
  useAxiosInstance,
} from 'shared/hooks/utils';

type IgnoreReminderVariables = {
  id: string;
};

export async function ignoreReminderFn(
  axiosInstance: Promise<AxiosInstance>,
  { id }: IgnoreReminderVariables,
): Promise<ApiResponse> {
  const instance = await axiosInstance;

  return instance.put(`/payment_requests/${id}/ignore`);
}

export function useIgnoreReminder() {
  const client = useQueryClient();
  const axiosInstance = useAxiosInstance();

  const mutation = useMutation<ApiResponse, ApiError, IgnoreReminderVariables>({
    mutationFn: variables => ignoreReminderFn(axiosInstance, variables),
    onSuccess: () => {
      client.invalidateQueries({
        queryKey: ['reminders'],
      });
    },
  });

  return addActionNameToMutationResult<
    ApiResponse,
    ApiError,
    IgnoreReminderVariables,
    'ignoreReminder'
  >('ignoreReminder', mutation);
}
